<template>
    <v-container fluid>
        <ConfirmDialog
            :is-open="showConfirmDialog"
            :data="confirmDialogData"
            @on-confirm="confirmDialogConfirm"
            @on-abort="confirmDialogClose"
        >
            <template #title>
                {{ confirmDialogData.title }}
            </template>
            <template #content>
                {{ confirmDialogData.content }}
            </template>
        </ConfirmDialog>
        <AddCampaignDialog
            :is-open="addCampaignDialog"
            @on-close="closeAddCampaignDialog"
            @campaign-created-by-file="campaignCreatedByFile"
        />
        <page-title>Kampanie JMD</page-title>
        <v-row align="center">
            <v-col cols="12" sm="4" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Utwórz kampanię"
                    @click="showAddCampaignDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Utwórz kampanię
                </v-btn>
            </v-col>
            <v-col cols="12" sm="8" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="auto">
                            <v-menu
                                v-model="filtersMenu"
                                top
                                left
                                transition="scroll-x-reverse-transition"
                                :close-on-content-click="false"
                            >
                                <template #activator="{on}">
                                    <v-btn
                                        fab
                                        :color="hasFilters ? 'secondary' : 'grey darken-1'"
                                        elevation="1"
                                        small
                                        v-on="on"
                                    >
                                        <v-icon v-if="hasFilters" color="white">
                                            mdi-filter-plus
                                        </v-icon>
                                        <v-icon v-else color="white">
                                            mdi-filter-minus
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-container fluid>
                                        <v-row justify="end" dense>
                                            <v-col cols="auto">
                                                <v-btn icon small @click="toggleFiltersMenu()">
                                                    <v-icon color="grey darken-2">
                                                        mdi-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" lg="12">
                                                <v-text-field
                                                    v-model="filters.search"
                                                    append-icon="mdi-magnify"
                                                    label="Szukaj..."
                                                    single-line
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @keyup.enter="changeFilter"
                                                    @click:append="changeFilter"
                                                    @click:clear="clearFilter('search')"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row justify="end">
                                            <v-col cols="12" md="6" lg="6">
                                                <v-select
                                                    v-model="filters.status_id"
                                                    label="Status"
                                                    :items="statuses"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Brak danych..."
                                                    solo
                                                    clearable
                                                    hide-details
                                                    single-line
                                                    @click:clear="clearFilter('status_id')"
                                                    @change="changeFilter()"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="3" lg="3">
                                                <v-menu
                                                    v-model="menuFrom"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.createdAt__gte"
                                                            label="Od:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('createdAt__gte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.createdAt__gte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuFrom = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="3" lg="3">
                                                <v-menu
                                                    v-model="menuTo"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.createdAt__lte"
                                                            label="Do:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('createdAt__lte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.createdAt__lte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuTo = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        name="listData"
                        :headers="headers"
                        :items="campaigns"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        :loading="campaignsLoading || closeCampaignLoading"
                        @pagination="updatePagination"
                    >
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.number="{item}">
                            {{ item.number }}
                        </template>
                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip 
                                    :open-delay="tooltipDelay"
                                    top
                                >
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Otwórz"
                                            v-on="on"
                                            @click="openCampaign(item.id)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                                <v-tooltip 
                                    :open-delay="tooltipDelay"
                                    top
                                >
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            text
                                            data-sentry-label="Zamknij"
                                            :disabled="item.status.id === 30 || !item.mayBeClosed"
                                            v-on="on"
                                            @click="tryCloseCampaign(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-archive-arrow-up-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Zamknij</span>  
                                </v-tooltip>
                                <v-tooltip
                                    :open-delay="tooltipDelay"
                                    top
                                >
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Usuń kampanię"
                                            :disabled="item.status.id === 30"
                                            v-on="on"
                                            @click="tryDeleteCampaignPosition(item)"
                                        >
                                            <v-icon color="pink">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Usuń</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import AddCampaignDialog from '@/views/Campaigns/Dialogs/AddCampaignDialog'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import dateFormatter from '@/mixins/dateFormatter'
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'

export default {
    name: 'CampaignsList',
    components: {
        PageTitle,
        AddCampaignDialog,
        ConfirmDialog,
    },
    mixins: [
        filters,
        pagination,
        dateFormatter,
        tooltipDelay,
    ],
    data() {
        return {
            campaignsLoading: false,
            filtersMenu: false,
            hasFilters: false,
            menuFrom: false,
            menuTo: false,
            addCampaignDialog: false,
            closeCampaignLoading: false,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Data wystawienia',
                    value: 'createdAt',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
            showConfirmDialog: false,
            confirmDialogData: {
                confirm: () => {},
            },
        }
    },
    computed: {
        campaigns() {
            return this.$store.state.campaigns.campaigns.list || []
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        statuses() {
            return this.$store.state.campaigns.campaigns.statuses
        },
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.$store.dispatch('campaigns/getCampaignStatuses')
        this.getCampaigns()
    },
    created() {
        this.checkFilters()
    },
    methods: {
        getCampaigns(callback = null) {
            this.campaignsLoading = true
            this.$store.dispatch('campaigns/getCampaigns', {
                paginate: this.paginate(),
                query: this.filterQuery,
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                    callback && callback()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.campaignsLoading = false
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getCampaigns()
            }
            this.clearPaginationPending()
        },
        toggleFiltersMenu() {
            this.filtersMenu = !this.filtersMenu
        },
        checkFilters() {
            this.hasFilters = !Object.values(this.filters).every(item => item == null || item.length == 0)
        },
        changeFilter() {
            this.resetPagination()
            this.checkFilters()
            this.getCampaigns()
        },
        campaignCreatedByFile() {
            this.getCampaigns(() => {
                this.$store.dispatch('showNotification', {
                    type: 'success',
                    message: 'Kampania została utworzona.'
                })
            })
        },
        showAddCampaignDialog() {
            this.addCampaignDialog = true
        },
        closeAddCampaignDialog() {
            this.addCampaignDialog = false
        },
        openCampaign(id) {
            this.$router.push({ name: 'campaignsCampaignsDetail', params: { id } })
        },
        deleteCampaign({ data }) {
            this.$store.dispatch('campaigns/deleteCampaign', data.id)
                .then(() => {
                    this.getCampaigns()
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        tryDeleteCampaignPosition(campaign) {
            this.confirmDialogData = {
                title: 'Usuwanie kampanii',
                content: 'Czy na pewno chcesz usunąć kampanię?',
                confirm: this.deleteCampaign,
                data: campaign,
            }
            this.showConfirmDialog = true
        },
        tryCloseCampaign(campaign) {
            this.confirmDialogData = {
                title: 'Zamknięcie kampanii',
                content: 'Czy na pewno chcesz zamknąć kampanię?',
                confirm: this.closeCampaign,
                data: campaign,
            }
            this.showConfirmDialog = true
        },
        confirmDialogConfirm(payload) {
            this.confirmDialogData.confirm(payload)
            this.confirmDialogClose()
        },
        confirmDialogClose() {
            this.showConfirmDialog = false
            setTimeout(() => {
                this.confirmDialogData = {
                    title: null,
                    content: null,
                    confirm: () => {},
                    data: null,
                }
            }, 500)
        },
        closeCampaign({ data }) {
            this.closeCampaignLoading = true
            this.$store.dispatch('campaigns/updateCampaign', {
                id: data.id,
                statusId: 30, // 30 - zamknięta
            })
                .then(() => {
                    this.getCampaigns(() => {
                        this.$store.dispatch('showNotification', {
                            type: 'success',
                            message: 'Kampania została zamknięta.'
                        })

                        this.closeCampaignLoading = false
                    })
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>
